// extracted by mini-css-extract-plugin
export var awaiting = "SupportHelpButton-module__awaiting___svUZG";
export var caseCard = "SupportHelpButton-module__caseCard___VKgfX";
export var caseList = "SupportHelpButton-module__caseList___GfM1p";
export var caseState = "SupportHelpButton-module__caseState___x1lLC";
export var caseTitle = "SupportHelpButton-module__caseTitle___+YF+e";
export var chatBody = "SupportHelpButton-module__chatBody___f8-fW";
export var chatFlyout = "SupportHelpButton-module__chatFlyout___CsC4K";
export var closeButton = "SupportHelpButton-module__closeButton___zUB5v";
export var closedCard = "SupportHelpButton-module__closedCard___MTGux";
export var closing = "SupportHelpButton-module__closing___SxbZJ";
export var dot = "SupportHelpButton-module__dot___GbSDH";
export var flyout = "SupportHelpButton-module__flyout___1lMzO";
export var flyoutBody = "SupportHelpButton-module__flyoutBody___9wNJD";
export var flyoutHeader = "SupportHelpButton-module__flyoutHeader___L5B8h";
export var flyoutIn = "SupportHelpButton-module__flyoutIn___rcgC7";
export var flyoutOut = "SupportHelpButton-module__flyoutOut___VhtPo";
export var helpButton = "SupportHelpButton-module__helpButton___+Ua9Z";
export var linkRow = "SupportHelpButton-module__linkRow___ESpa0";
export var newReply = "SupportHelpButton-module__newReply___zmvSP";
export var replyTime = "SupportHelpButton-module__replyTime___zwTM-";
export var resourceCard = "SupportHelpButton-module__resourceCard___mqK3c";
export var resourceDescription = "SupportHelpButton-module__resourceDescription___UDJGv";
export var resourceList = "SupportHelpButton-module__resourceList___CUGsA";
export var resourceTitle = "SupportHelpButton-module__resourceTitle___QK9nu";
export var restored = "SupportHelpButton-module__restored___vOK3p";
export var section = "SupportHelpButton-module__section___BxDdF";
export var textLink = "SupportHelpButton-module__textLink___CVSW7";